export default {
	items: [
		/*{
			name: 'Dashboard',
			url: '/dashboard',
			icon: 'icon-speedometer',
			badge: {
				variant: 'primary',
				text: 'NEW'
			}
		},*/
		/*{
			title: true,
			name: 'MyCadfem',
			class: '',
			wrapper: {
				element: '',
				attributes: {}
			}
		},*/
		{
			name: 'Новости',
			url: '/documents',
			icon: 'icon-info',
		},
		{
			name: 'Мероприятия',
			icon: 'icon-grid',
			url: "/events-conferences",
			children: [
				{
					name: 'Конференции',
					icon: 'icon-calendar',
					url: "/events-conferences",
				},
				{
					name: 'Вебинары',
					icon: 'icon-calendar',
					url: "/events-webinars",
				},
				{
					name: 'Мои мероприятия',
					url: '/registrations',
					icon: 'icon-user',
					// variant: 'green',
				},
			]
		},
		{
			name: 'Курсы',
			url: '/courses',
			icon: 'icon-badge'
		},
		{
			name: 'Опыт применения',
			url: '/experience',
			icon: 'icon-chart'
		},
		{
			divider: true
		},
		{
			name: 'Библиотека',
			icon: 'icon-graduation',
			url: "/lib",
			children: [
				{
					name: 'Вебинары',
					url: '/lib/webinars',
					icon: 'icon-social-youtube',
					/*badge: {
						variant: 'danger',
						text: 'NEW'
					},*/
				},
				{
					name: 'Видео-уроки',
					url: '/lib/video-lessons',
					icon: 'icon-film'
				},
				{
					name: 'Статьи',
					url: '/lib/articles',
					icon: 'icon-docs'
				},
			],
		},
		{
			divider: true
		},
		{
			name: 'Ресурсы',
			icon: 'icon-graduation',
			url: "/resources",
			children: [
				{
					name: 'Журналы',
					url: '/resources/journals',
					icon: 'icon-book-open',
				},
				{
					name: 'Каталоги',
					url: '/resources/catalogs',
					icon: 'icon-grid'
				},
				{
					name: 'Тех. документация',
					url: '/resources/soft-updates',
					icon: 'icon-reload'
				},
				{
					name: 'Презентации',
					url: '/resources/presentations',
					icon: 'icon-docs'
				},
			],
		},
		{
			divider: true
		},
		/*{
			name: 'Widgets',
			url: '/widgets',
			icon: 'icon-calculator',
			badge: {
				variant: 'primary',
				text: 'NEW'
			},
			attributes: {disabled: true},
		},*/
		/*{
			name: 'Download CoreUI',
			url: 'http://coreui.io/vue/',
			icon: 'icon-cloud-download',
			class: 'mt-auto',
			variant: 'success',
			attributes: {target: '_blank', rel: 'noopener'}
		},
		{
			name: 'Try CoreUI PRO',
			url: 'http://coreui.io/pro/vue/',
			icon: 'icon-layers',
			variant: 'danger',
			attributes: {target: '_blank', rel: 'noopener'}
		},*/
		{
			name: 'Тех. поддержка',
			url: 'https://sc.cadfem-cis.ru/',
			icon: 'icon-globe',
			class: 'mt-auto',
			// variant: 'success',
			attributes: { target:'_blank', rel:'nofollow' }
		},
		{
			name: 'eCADFEM',
			url: 'https://ecadfem.ru/',
			icon: 'icon-globe',
			attributes: { target:'_blank', rel:'nofollow' }
		},
		{
			name: 'eLearning',
			url: 'https://elearning.cadfem-cis.ru/',
			icon: 'icon-globe',
			attributes: { target:'_blank', rel:'nofollow' }
		},
	]
}
